import { kuesionerData } from './kuesioner';

// General function to get recommendations based on assessment type
export function getAssessmentRecommendations(type, score, total, ageInMonths, additionalData = {}) {
    let resultKey;
    let resultData;
    let followUp = null;

    switch (type) {
        case 'kpsp':
        case 'perkembangan':
            if (score >= 9) resultKey = 'sesuai';
            else if (score >= 7) resultKey = 'meragukan';
            else resultKey = 'penyimpangan';
            resultData = kuesionerData.kpspResult[resultKey];
            if (resultKey === 'sesuai') followUp = `Lakukan skrining KPSP lagi pada usia ${ageInMonths + 3} bulan.`;
            if (resultKey === 'meragukan') followUp = 'Lakukan skrining KPSP ulang dalam 2 minggu. Jika hasil tetap sama, konsultasikan dengan dokter.';
            if (resultKey === 'penyimpangan') followUp = 'Segera rujuk ke fasilitas kesehatan untuk evaluasi lebih lanjut.';
            break;

        case 'kmme':
        case 'mental':
            if (score === 0) resultKey = 'normal';
            else if (score === 1) resultKey = 'ringan';
            else resultKey = 'tinggi';
            resultData = kuesionerData.kmmeResult[resultKey];
            break;

        case 'gpph':
            resultKey = score < 13 ? 'normal' : 'kemungkinan';
            resultData = kuesionerData.gpphResult[resultKey];
            break;

        case 'chat':
            resultKey = score <= 2 ? 'rendah' : 'terdeteksi';
            resultData = kuesionerData.chatResult[resultKey];
            break;

        case 'tdd':
            resultKey = score === 0 ? 'normal' : 'gangguan';
            resultData = {
                ...kuesionerData.tdd.results[resultKey],
                recommendations: kuesionerData.tdd.recommendations[resultKey]
            };
            break;

        case 'tdl':
        case 'dayaLihat':
            resultKey = score === 0 ? 'normal' : 'gangguan';
            resultData = {
                ...kuesionerData.pemeriksaanMata.dayaLihat.results[resultKey],
                recommendations: kuesionerData.pemeriksaanMata.dayaLihat.recommendations[resultKey]
            };
            break;

        case 'pupilPutih':
            resultKey = score === 0 ? 'normal' : 'penyimpangan';
            resultData = {
                ...kuesionerData.pemeriksaanMata.pupilPutih.results[resultKey],
                recommendations: kuesionerData.pemeriksaanMata.pupilPutih.recommendations[resultKey]
            };
            break;

        default:
            resultData = {
                status: 'Tidak Diketahui',
                interpretation: 'Jenis pemeriksaan tidak dikenali.',
                recommendations: ['Konsultasi dengan tenaga kesehatan'],
                urgency: 'medium'
            };
    }

    if (!resultData) {
        return {
            status: 'Data Tidak Ditemukan',
            interpretation: 'Tidak dapat menemukan data hasil untuk asesmen ini.',
            recommendations: ['Silakan coba lagi atau hubungi dukungan teknis.'],
            urgency: 'medium'
        };
    }

    return followUp ? { ...resultData, followUp } : resultData;
}